import { render, staticRenderFns } from "./IconHisList.vue?vue&type=template&id=0dba57b4&"
import script from "./IconHisList.vue?vue&type=script&lang=js&"
export * from "./IconHisList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports